import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { NbcSharedModule } from "../shared/shared.module";
import { BusinessUnitComponent } from "./business-unit/business-unit.component";
import { DashboardLayoutComponent } from "./layout/dashboard-layout.component";
import { OpsTalentDeptComponent } from "./ops-tal-dept/ops-tal-dept.component";
import { FinPayrollDeptComponent } from "./fin-pay-dept/fin-pay-dept.component";
import { CreateTSComponent } from "./create-ts/create-ts.component";
import { TabsModule } from "ngx-bootstrap/tabs";
import { TsSummaryGridComponent } from "./ops-tal-dept/card-grid/ts-summary-grid.component";
import { TimesheetCardComponent } from "./ops-tal-dept/ts-card/timesheet-card.component";
import { TimecardTemplateListComponent } from "./template/list/template-list.component";
import { TemplateFilterComponent } from "./template/filter/template-filter.component";
import { ModalCreateTemplateComponent } from "./template/create-template/modal-create-template.component";
import { TemplateLayoutComponent } from "./template/layout/template-layout.component";
import { ModalModule } from "ngx-bootstrap/modal";
import { ModalCloneTemplateComponent } from "./template/clone/modal-clone-template.component";
import { NgChartsModule } from "ng2-charts";
import { ApprovedTimecardsComponent } from "./fin-pay-dept/charts/approved-tc/approved-timecards.component";
import { PendingTimecardComponent } from "./fin-pay-dept/charts/pending-tc/pending-timecard.component";
import { PendingTimecardDeptComponent } from "./fin-pay-dept/charts/pending-tc-dept/pending-timecard-dept.component";
import { ReportLayoutComponent } from "./report/report-layout.component";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { AccordionModule } from "ngx-bootstrap/accordion";
import { TransactionReportComponent } from "./report/transaction-report/transaction-report.component";
import { TypeaheadModule } from "ngx-bootstrap/typeahead";
import { ArchiveExportComponent } from "./archive/archive-export.component";
import { TemplateDetailsLayoutComponent } from "./template-details/layout/template-details-layout.component";
import { TemplateDetailsFilterComponent } from "./template-details/filter/template-details-filter.component";
import { TemplateDetailsGridComponent } from "./template-details/template-details-grid/template-details-grid.component";
import { ModalCreateTimesheetComponent } from "./create-ts/modal-create/modal-create-timesheet.component";
import { GlAccountTemplateComponent } from "./template-details/components/glaccount/glaccount-templatet.component";
import { BuTemplateListComponent } from "./template/bu-template-list/bu-template-list.component";
import ChartDataLabels from "chartjs-plugin-datalabels";
import Chart from "chart.js/auto";
import { OnboardingComponent } from "./onboarding/onboarding-component";
import { OnboardingLayoutRequestComponent } from "./onboarding/request/request-layout-component";
import { OnboardingRequestComponent } from "./onboarding/request/list/request-grid-component";

import { OnboardingHistoryLayoutComponent } from "./onboarding/history/history-layout-component";
import { OnboardingHistoryComponent } from "./onboarding/history/list/history-grid-component";
import { EditPositionRequestComponent } from "./onboarding/request/list/editPositionRequest.component";



@NgModule({
  declarations: [
    DashboardLayoutComponent,
    BusinessUnitComponent,
    OpsTalentDeptComponent,
    FinPayrollDeptComponent,
    CreateTSComponent,
    TsSummaryGridComponent,
    TimesheetCardComponent,
    TemplateLayoutComponent,
    TimecardTemplateListComponent,
    TemplateFilterComponent,
    ModalCreateTemplateComponent,
    ModalCreateTimesheetComponent,
    ModalCloneTemplateComponent,
    ApprovedTimecardsComponent,
    PendingTimecardComponent,
    PendingTimecardDeptComponent,
    ReportLayoutComponent,
    TransactionReportComponent,
    ArchiveExportComponent,
    TemplateDetailsLayoutComponent,
    TemplateDetailsFilterComponent,
    TemplateDetailsGridComponent,
    GlAccountTemplateComponent,
    BuTemplateListComponent,
    OnboardingComponent,
    OnboardingLayoutRequestComponent,
    OnboardingRequestComponent,
    OnboardingHistoryLayoutComponent,
    OnboardingHistoryComponent,
    EditPositionRequestComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    NbcSharedModule,
    RouterModule,
    TabsModule,
    ModalModule.forRoot(),
    NgChartsModule,
    BsDatepickerModule.forRoot(),
    AccordionModule.forRoot(),
    TypeaheadModule.forRoot(),
  ],
  providers: [],
})
export class DashboardModule {
  constructor() {
    Chart.register(ChartDataLabels);
  }
}
